import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { useSignInDialog } from '@/hooks/use-sign-in-dialog';
export function UnauthenticatedOverlay() {
  const $ = _c(5);
  const t = useTranslations();
  const {
    openDialog
  } = useSignInDialog();
  let t0;
  if ($[0] !== t) {
    t0 = t("common.sign-in");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== openDialog || $[3] !== t0) {
    t1 = <div className="absolute inset-0 flex items-center justify-center rounded-md bg-black/5 backdrop-blur-[0.8px]"><Button size="sm" onClick={openDialog}>{t0}</Button></div>;
    $[2] = openDialog;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}